import useAuthStore from '@/stores/useAuthStore'
import { useMemo } from 'react'
import DraggableLayout, { WidgetConfig } from '../shared/DraggableLayout'

// Import existing components
import Business from '@/modules/Dashboard/components/shared/Business'
import TargetRevenue from '@/modules/Dashboard/components/shared/TargetRevenue'
import WorkDays from '@/modules/Dashboard/components/shared/WorkDays'
import MyWorkdays from '../../shared/MyWorkdays'
import Notifications from '../../shared/Notifications'
import LeadsStatistics from '../../shared/LeadsStatistics'
import QuoteOfTheDay from '../../shared/QuoteOfTheDay'
import InternalInformation from '../../shared/InternalInformation'

// Import Sales specific widgets
import ConversionFunnelWidget from './widgets/ConversionFunnelWidget'
import DailyInputWidget from './widgets/DailyInputWidget'
import SalesAlertsWidget from './widgets/SalesAlertsWidget'
import SalesOncallScheduleWidget from './widgets/SalesOncallScheduleWidget'
import Paper from '@/components/Paper'
import Events from '../../shared/Events'
import SLACustomersWidget from '../shared/widgets/SLACustomersWidget'

const SalesDashboard = () => {
    const employee = useAuthStore((state) => state.employee)

    // Storage key unique per employee
    const storageKey = useMemo(
        () => `dashboard_layout_sales_${employee?.employee_id || 'default'}`,
        [employee?.employee_id]
    )

    // Widget configurations with colSpan (4, 6, 8, or 12)
    const widgets: WidgetConfig[] = useMemo(
        () => [
            {
                id: 'quote_of_the_day',
                component: (
                    <Paper className="h-full">
                        <QuoteOfTheDay />
                    </Paper>
                ),
                colSpan: 12,
            },
            {
                id: 'revenue',
                component: (
                    <Paper className="h-full">
                        <TargetRevenue />
                    </Paper>
                ),
                colSpan: 6,
            },
            {
                id: 'daily-input',
                component: <DailyInputWidget />,
                colSpan: 6,
            },
            {
                id: 'conversion-funnel',
                component: <ConversionFunnelWidget />,
                colSpan: 6,
            },
            {
                id: 'leads-statistics',
                component: <LeadsStatistics />,
                colSpan: 3,
            },
            {
                id: 'alerts',
                component: <SalesAlertsWidget />,
                colSpan: 3,
            },
            {
                id: 'sales-oncall-schedule',
                component: (
                    <Paper className="h-full">
                        <SalesOncallScheduleWidget />
                    </Paper>
                ),
                colSpan: 6,
            },
            {
                id: 'business',
                component: (
                    <Paper className="h-full">
                        <Business />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'my_workdays',
                component: (
                    <Paper className="h-full">
                        <MyWorkdays />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'notification',
                component: (
                    <Paper className="h-full">
                        <Notifications />
                    </Paper>
                ),
                colSpan: 6,
            },
            {
                id: 'workday',
                component: (
                    <Paper className="h-full">
                        <WorkDays />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'events',
                component: (
                    <Paper className="h-full">
                        <Events />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'sla-customers',
                component: <SLACustomersWidget />,
                colSpan: 4,
            },
            {
                id: 'internal-information',
                component: (
                    <Paper className="h-full">
                        <InternalInformation />
                    </Paper>
                ),
                colSpan: 9,
            },
        ],
        []
    )

    return (
        <DraggableLayout
            widgets={widgets}
            storageKey={storageKey}
            department="SALES"
        />
    )
}

export default SalesDashboard
